/**
 * Session PIN côté tablette — « la tablette est authentifiée, le vendeur est
 * identifié » (docs/specs/pin-switch-vendeur.md §2).
 *
 * La session Clerk reste celle du superviseur du magasin. Ce module ne fait
 * que retenir **au nom de qui** la tablette agit : `apiClient` lit ce flag à
 * chaque requête et envoie `X-Acting-As`. Le serveur revérifie tout
 * (superviseur, réseau PIN activé, vendeur du magasin) : forger la valeur en
 * localStorage ne donne rien que la session n'ait déjà — au contraire, elle
 * RÉDUIT les droits au périmètre d'un vendeur.
 *
 * Même patron que `impersonation.ts`, volontairement distinct : l'un est un
 * outil d'administration tracé par requête, l'autre un vendeur qui prend
 * son poste.
 */
const ID_KEY = 'doorly:actingAs:userId';
const NAME_KEY = 'doorly:actingAs:displayName';
const DEVICE_KEY = 'doorly:actingAs:deviceUserId';

function read(key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function getActingAsUserId(): string | null {
  return read(ID_KEY);
}

export function getActingAsDisplayName(): string | null {
  return read(NAME_KEY);
}

/** Le superviseur dont la session porte la tablette (celui qui a ouvert l'accès). */
export function getActingDeviceUserId(): string | null {
  return read(DEVICE_KEY);
}

export function isActingAs(): boolean {
  return getActingAsUserId() !== null;
}

export function setActingAs(userId: string, displayName: string, deviceUserId: string): void {
  localStorage.setItem(ID_KEY, userId);
  localStorage.setItem(NAME_KEY, displayName);
  localStorage.setItem(DEVICE_KEY, deviceUserId);
}

export function clearActingAs(): void {
  localStorage.removeItem(ID_KEY);
  localStorage.removeItem(NAME_KEY);
  localStorage.removeItem(DEVICE_KEY);
}
